<template>
<Expose class="beautify" :ratio="0.2" @expose="$emit('expose')">
    <h2 class="beautify-title">美化图片</h2>
    <div class="beautify-content">
        <div class="beautify-content-block" @click="open">
            <img draggable="false" class="beautify-img" src="https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-105624-699b.png" alt="">
            <div class="right">
                <div class="text">
                    <h3 class="title">在线编辑图片</h3>
                    <p class="desc">简单、专业、全能的在线图片编辑器</p>
                </div>
                <UploadBtn @upload="handleUpload" class="beautify-btn"/>
            </div>
        </div>
    </div>
    <p class="beautify-footer">
        了解完整图片编辑器功能
        <a href="https://www.gaoding.com/image" target="_blank" draggable="false">立即前往</a>
    </p>
</Expose>

</template>
<script>
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UploadBtn from '../upload-btn';
import Expose from '../../../expose';
export default {
  name: 'beautify',
  components: {
    UploadBtn,
    Expose
  },
  props: {
    // 上传图片函数，应该返回一个value为图片url的promise
    uploadFunc: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleUpload(files) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.uploadFunc(files, 'https://www.gaoding.com/design/image?url=');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    open() {
      window.open('https://www.gaoding.com/image');
    }

  }
};
</script>
<style scoped>
h2,
h3,
p {
  margin: 0;
  padding: 0;
}
img {
  user-select: none;
}
.beautify {
  width: 602px;
  height: 330px;
  padding: 34px;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  color: #33383E;
}
.beautify-title {
  margin: 0;
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  text-align: left;
  margin-bottom: 20px;
}
.beautify-content a {
  text-decoration: none;
}
.beautify-content-block {
  height: 172px;
  background: #F6F7F9;
  display: flex;
}
.beautify-content-block .beautify-img {
  width: 210px;
  height: 172px;
  margin-left: 30px;
}
.beautify-content-block:hover {
  background: #FFFFFF;
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s, background-color 0.2s;
}
.beautify-content-block:hover .right .text {
  transition: margin-top 0.3s;
  margin-top: 32px !important;
}
.beautify-content-block:hover .right .beautify-btn {
  opacity: 1;
  transition: opacity 0.2s linear 0.3s;
}
.beautify-content-block .right {
  flex: 1;
  margin-left: 34px;
}
.beautify-content-block .right .text {
  transition: margin-top 0.3s 0.2s;
  margin-top: 60px;
}
.beautify-content-block .right .text .title {
  font-weight: 500;
  font-size: 22px;
  line-height: 20px;
  color: #444950;
}
.beautify-content-block .right .text .desc {
  margin-top: 12px;
  font-size: 13px;
  line-height: 20px;
  color: #7F8792;
}
.beautify-content-block .right .beautify-btn {
  margin-top: 20px;
  opacity: 0;
  transition: opacity 0.2s linear;
}
.beautify-footer {
  margin: 0;
  font-size: 14px;
  line-height: 14px;
  text-align: left;
  margin-top: 20px;
  color: #636C78;
}
.beautify-footer a {
  color: #2254F4;
  text-decoration: none;
}
.beautify-footer a:hover {
  font-weight: bold;
}

</style>
